import React from 'react';
import {
    Col, Row, Modal, FormControl, FormGroup, ControlLabel, Form
} from 'react-bootstrap';
import Select from 'react-select';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import ModalBlockWrapper from '../Components/ModalBlockWrapper.jsx';

class ModalExport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      calendarioSelect: '',
      desde: '',
      hasta: '',
      error: {},
    };

    this.generateOptions = this.generateOptions.bind(this);
    this.clearError = this.clearError.bind(this);
  }

  clearError(key) {
    const auxError = this.state.error;
    auxError[key] = false;
    this.setState({error: auxError});
  }

  generateOptions() {
    return this.props.calendariosList.map((item) => {
      return {value: item.id, label: item.nombre};
    })
  }

  checkErrors(exported) {
    const auxError = this.state.error;
    let error = false;
    Object.keys(exported).forEach((key) => {
      if (!exported[key] || exported[key] === '') {
        auxError[key] = true;
        error = true;
      }
    });
    this.setState({error: auxError});
    return error;
  }

  exportCalendar() {
    const id = this.state.calendarioSelect ? this.state.calendarioSelect.value : null;
    const exported = {
      id,
      start: this.state.desde,
      end: this.state.hasta,
    };

    const error = this.checkErrors(exported);

    if (!error) {
      this.props.exportCalendar(exported);
    } else {
      this.props.errorAlert(
        <div>
          Uno o mas campos requeridos no han sido completados!
        </div>);
    }
  }

  render() {
    return (
      <Modal show onHide={() => this.props.closeModal()} style={{ display: "block" }}>
        <ModalBlockWrapper
          content={
            <div>
              <Modal.Header closeButton>
                <Modal.Title>Exportar Calendario</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col md={12}>
                    <Form>
                      <FormGroup validationState={this.state.error.id ? 'error': null}>
                        <ControlLabel>{'Calendario'} </ControlLabel>
                        <Select
                          style={{ borderColor: this.state.error.id ? "#e40040" : "#aaa"}}
                          placeholder="Seleccione Calendario"
                          name="usersCalendar"
                          value={this.state.calendarioSelect}
                          options={this.generateOptions()}
                          onChange={(item) => this.setState({calendarioSelect: item}, this.clearError('id'))}
                        />
                      </FormGroup>
                    </Form>
                  </Col>
                  <Col md={6}>
                    <Form>
                      <FormGroup validationState={this.state.error.start ? 'error': null}>
                        <ControlLabel>{'Desde'} </ControlLabel>
                        <FormControl
                          type="date" value={this.state.desde ? this.state.desde : ''}
                          onChange={(e) => this.setState({desde: e.target.value}, this.clearError('start'))}
                        />
                      </FormGroup>
                    </Form>
                  </Col>
                  <Col md={6}>
                    <Form>
                      <FormGroup validationState={this.state.error.end ? 'error': null}>
                        <ControlLabel>{'Hasta'} </ControlLabel>
                        <FormControl
                          type="date" value={this.state.hasta ? this.state.hasta : ''}
                          onChange={(e) => this.setState({hasta: e.target.value}, this.clearError('end'))}
                        />
                      </FormGroup>
                    </Form>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button simple onClick={this.props.closeModal}>
                  Cancelar
                </Button>
                <Button
                  bsStyle="success" fill onClick={() => this.exportCalendar()}
                >
                  Exportar
                </Button>
              </Modal.Footer>
            </div>
          }
        />
      </Modal>
    );
  }
}

export default ModalExport;



// WEBPACK FOOTER //
// ./src/views/Calendar/ModalExport.jsx